// @flow
import SavedTranscriptTypes from '../action-types/saved-transcript';
import {
  filterAccessibleTranscripts,
  filterDeletedTranscript,
  retrieveLastReadTranscript,
  updateTranscripts,
} from '../reducer-utils/saved-transcript';

import { SavedTranscript } from '../types/saved-transcript';

export interface State {
  loading: boolean;
  deleteLoading: true;
  updateTitleLoading: true;
  hasMoreTranscripts: boolean;
  lastReadTimestamp: number | null;
  transcripts: SavedTranscript[];
  selectedId: string;
  error: string;
}

const INITIAL_STATE = {
  loading: false,
  deleteLoading: false,
  updateTitleLoading: false,
  hasMoreTranscripts: true,
  lastReadTimestamp: null,
  transcripts: [],
  selectedId: '',
  error: '',
};

// $FlowFixMe
const savedTranscriptReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SavedTranscriptTypes.FETCH_TRANSCRIPTS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case SavedTranscriptTypes.FETCH_TRANSCRIPTS_SUCCESS:
      return {
        ...state,
        loading: false,
        lastReadTimestamp: retrieveLastReadTranscript(action.payload).startTimestampMs,
        transcripts: filterAccessibleTranscripts(state.transcripts, action.payload),
      };

    case SavedTranscriptTypes.FETCH_TRANSCRIPTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SavedTranscriptTypes.SET_HAS_MORE_TRANSCRIPTS:
      return {
        ...state,
        loading: false,
        hasMoreTranscripts: action.payload,
      };

    case SavedTranscriptTypes.DELETE_TRANSCRIPT_REQUEST:
      return {
        ...state,
        deleteLoading: true,
      };

    case SavedTranscriptTypes.DELETE_TRANSCRIPT_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        transcripts: filterDeletedTranscript(state.transcripts, action.payload),
      };

    case SavedTranscriptTypes.DELETE_TRANSCRIPT_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        error: action.payload,
      };

    case SavedTranscriptTypes.SET_SELECTED_TRANSCRIPT_ID:
      return {
        ...state,
        selectedId: action.payload,
      };

    case SavedTranscriptTypes.RESET_TRANSCRIPTS:
      return {
        ...state,
        hasMoreTranscripts: true,
        lastReadTimestamp: null,
        loading: false,
        transcripts: [],
      };

    case SavedTranscriptTypes.UPDATE_TRANSCRIPT_TITLE_REQUEST:
      return {
        ...state,
        updateTitleLoading: true,
      };

    case SavedTranscriptTypes.UPDATE_TRANSCRIPT_TITLE_SUCCESS:
      return {
        ...state,
        updateTitleLoading: false,
        transcripts: updateTranscripts(state.transcripts, action.payload),
      };

    case SavedTranscriptTypes.UPDATE_TRANSCRIPT_TITLE_FAILURE:
      return {
        ...state,
        updateTitleLoading: false,
        error: action.payload,
      };

    case SavedTranscriptTypes.ADD_NEW_TRANSCRIPT:
      return {
        ...state,
        lastReadTimestamp: state.transcripts.length
          ? retrieveLastReadTranscript(state.transcripts).startTimestampMs
          : action.payload.startTimestampMs,
        transcripts: filterAccessibleTranscripts([action.payload], state.transcripts),
      };

    default:
      return state;
  }
};

export default savedTranscriptReducer;
